export const POPOVER_Z = 10_000
export const SIDEBAR_Z = 1_000
